import { downloads } from "@/mocks/downloadData";
import { toneIconClass, toneBadgeClass } from "./tones";

export default function DownloadPanel() {
  return (
    <section id="downloads" className="scroll-mt-20">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-shell">
          <div className="max-w-2xl">
            <span className="text-sm text-primary-700 font-label">工具下载</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              想装到本地用？下载入口摆在这儿
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              部分工具除了网页版还提供客户端或浏览器扩展。这里只挂官方来源，并标注平台与版本，下载前建议再核对一次。
            </p>
          </div>

          <div className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {downloads.map((item) => (
              <article
                key={item.name}
                className="flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200"
              >
                <div className="flex items-start gap-4">
                  <span
                    className={`shrink-0 w-12 h-12 rounded-lg border flex items-center justify-center ${toneIconClass[item.tone]}`}
                  >
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-lg font-semibold text-foreground-950">
                        {item.name}
                      </h3>
                      <span
                        className={`px-2 py-0.5 rounded-full border text-[11px] ${toneBadgeClass[item.tone]}`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>

                <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-device-line"></i>
                    {item.platform}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-git-branch-line"></i>
                    {item.version}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-hard-drive-2-line"></i>
                    {item.size}
                  </span>
                </div>

                <div className="mt-5 flex items-center gap-3">
                  <a
                    href="#downloads"
                    className="flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-download-2-line"></i>
                    下载安装包
                  </a>
                  <a
                    href="#downloads"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    查看更新日志
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}